"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "What should I wear for my session?",
  answer: "We recommend pieces that make you feel most confident, from delicate lace to structured bodysuits. Our curated styling guide provides inspiration to help you select a wardrobe that perfectly reflects your personal elegance and style."
}, {
  question: "Do you offer on-location photography?",
  answer: "Yes, we specialize in high-end on-location shoots at luxury hotels, professional studios, or the privacy of your home. We ensure every setting is carefully curated to provide a sophisticated, comfortable, and discreet atmosphere."
}, {
  question: "How do you handle client privacy?",
  answer: "Your discretion is our priority. We maintain strict confidentiality throughout the entire process and never share your images without explicit written consent, ensuring your boudoir journey remains a private and empowering celebration."
}, {
  question: "Is professional hair and makeup included?",
  answer: "We partner with elite local stylists to offer professional hair and makeup services. This high-end addition ensures you feel like the best version of yourself, with camera-ready glamour tailored specifically to your unique features."
}, {
  question: "How do I book an XO experience?",
  answer: <>
        You can begin your journey through our{" "}
        <Link to="/HomePage" className="text-primary hover:underline underline-offset-4">
          Home page
        </Link>{" "}
        or reach out at hello@xoboudoir.com to discuss your vision and availability for a luxury session in the Minneapolis area.
      </>
}];
export default function CommonQuestions() {
  return <section data-section-id="132963" id="common-curiosities" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-[800px]">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-foreground mb-4 tracking-tight">
            Common Curiosities
          </h2>
          <p className="text-muted-foreground text-lg font-sans tracking-wider">
            Explore the details of our bespoke boudoir experience and prepare for your day of empowerment.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full border-t border-border">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border">
              <AccordionTrigger className="text-[18px] font-sans font-medium text-foreground hover:no-underline hover:text-primary transition-colors py-6 tracking-wide">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 font-sans font-light tracking-wider">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}